import {useCallback} from 'react'

import {usePlantMonitoring} from '../context/PlantMonitoringContext'

export const useSignalDescription = () => {
  const {
    state: {uiLayout}
  } = usePlantMonitoring()

  const getDescription = useCallback(
    ({name, description}: {name?: string; description?: string}) => {
      if (uiLayout.englishDescription) {
        return name || description || '-'
      } else {
        return description || name || '-'
      }
    },
    [uiLayout.englishDescription]
  )
  return getDescription
}
